import React, { useEffect, useRef, useState } from 'react'
import Button from '../../components/atoms/Buttons'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import ManufacturerTable from '../../components/ManufacturerTable'
import Pagination from '../../components/Pagination/Pagination'
import MainLayout from '../../components/Layout'
import { LIST_MANUFACTURERS_FULL } from '../../apollo/queries/listManufacturers'

function Manufacturers() {
  const navigate = useNavigate()
  const sidebarRef = useRef(null)
  const dropdownRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [toggle, setToggle] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null })

  const { data, loading } = useQuery(LIST_MANUFACTURERS_FULL, {
    fetchPolicy: 'network-only',
  })
  console.log('Manufacturers Data:', data?.listManufacturers)

  const itemsPerPage = 10

  const filteredManufacturers = React.useMemo(() => {
    return data?.listManufacturers?.filter(m => m.type === 'Admin') || []
  }, [data])

  const paginatedManufacturers = React.useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return filteredManufacturers.slice(startIndex, endIndex)
  }, [filteredManufacturers, currentPage])

  const totalPages = Math.ceil(filteredManufacturers.length / itemsPerPage)

  const loadNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1)
    }
  }

  const loadPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1)
    }
  }

  const handleSort = key => {
    setSortConfig(prevConfig => {
      const direction =
        prevConfig?.key === key && prevConfig?.direction === 'ascending'
          ? 'descending'
          : 'ascending'
      return { key, direction }
    })
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(!isOpen)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setToggle(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [sidebarRef])

  return (
    <MainLayout>
      <div className="w-full flex items-center flex-wrap justify-between mb-5 sm:mb-0 h-auto">
        <h1 className="admin-dashboard">Manufacturers</h1>
        <Button
          onClick={() => navigate('/manufacturers/create')}
          className="create-saddle-btn cursor-pointer"
        >
          Add Manufacturer
        </Button>
      </div>

      {/* Manufacturers Table */}
      <ManufacturerTable
        loading={loading}
        manufacturers={paginatedManufacturers}
        sortConfig={sortConfig}
        handleSort={handleSort}
      />

      {/* Pagination */}
      <Pagination
        loadNextPage={loadNextPage}
        loadPreviousPage={loadPreviousPage}
        canLoadNext={currentPage < totalPages}
        canLoadPrevious={currentPage > 1}
      />
    </MainLayout>
  )
}

export default Manufacturers
